/**
 * How the user responded to the popup
 */
export enum PopUpNotificationResponseType {
    /** user accepted (pressed 'Ok' or 'Confirm') */
    Accepted = 0,
    /** user denied (did not  press 'Confirm') */
    Denied = 1,
    /** user pressed 'Cancel' */
    Cancelled = 2,
    /** an error occurred and the popup was not displayed */
    Error = 3
}